module.exports = __webpack_public_path__ + "img/movie1.63607b34.png";